import { atom } from "recoil";

export const NewConnectedDeviceState = atom<boolean>({
  key: "newConnectedDeviceState",
  default: false,
});
